enum PromiseState {
  Pending = 0,
  Fulfilled = 1,
  Rejected = 2,
}

/**
 * 使傳入的 Promise 至少等待到滿足 {timeout} 時間後，才會觸發 fulfilled
 * @param promise 一個要等待的 Promise
 * @param timeout 必須等待滿足的時間 (毫秒)
 */
export function useWaitAtLeast<T>(promise: Promise<T>, timeout = 800): Promise<T> {
  const timer = useTimestamp()
  const startAt: number = timer.value
  const state = ref<PromiseState>(0) // promise 執行狀態

  // promise 的回傳資料
  let fulfilled: T
  let rejected: any

  const timedup = computed(() => timer.value - startAt > timeout)
  const finished = computed(() => timedup.value && state.value > PromiseState.Pending) // 完成條件：時間到，且 promise 已經回傳

  // 跑完原先的 Promise，並紀錄狀態
  promise.then((value) => {
    fulfilled = value
    state.value = PromiseState.Fulfilled
  }).catch(e => {
    rejected = e
    state.value = PromiseState.Rejected
  })

  // 產生一個新的 Promise，並且等待滿足時間條件
  return new Promise((resolve, reject) => {
    whenever(finished, () => {
      if (state.value === PromiseState.Fulfilled) {
        resolve(fulfilled)
      } else if (state.value === PromiseState.Rejected) {
        reject(rejected)
      }
    })
  })
}
